export default "__VITE_ASSET__CANuQ5de__"